export default "__VITE_PUBLIC_ASSET__035113ae__"